import script from "./add-task-num-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./add-task-num-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__